import React, { FC } from 'react'
import { useTranslation } from 'next-i18next'
import styles from './styles.module.css'

import ModalLayout from 'components/commons/layouts/ModalLayout'
import ModalButtonLayout from 'components/commons/layouts/ModalButtonLayout'

type Props = {
  isVisible: boolean
  onClose: () => void
  onSubmit: () => void
}

export const DuplicateReserveModal: FC<Props> = ({ isVisible, onClose, onSubmit }) => {
  const { t } = useTranslation()

  return (
    <ModalLayout openModal={isVisible} onPressCloseModalRequest={onClose} modalStyle={styles.modal}>
      <p className={styles.title}>{t('BOOKING.MODAL.DUPLICATE_RESERVE.TITLE')}</p>
      <div className={styles.contentContainer}>
        <p className={styles.content}>{t('BOOKING.MODAL.DUPLICATE_RESERVE.CONTENT_FIRST_LINE')}</p>
        <p className={styles.content}>{t('BOOKING.MODAL.DUPLICATE_RESERVE.CONTENT_SECOND_LINE')}</p>
      </div>
      <div className={styles.buttonContainer}>
        <ModalButtonLayout buttonStyle={styles.cancelButton} clickEvent={onClose}>
          <p>{t('BOOKING.MODAL.DUPLICATE_RESERVE.CANCEL')}</p>
        </ModalButtonLayout>
        <ModalButtonLayout buttonStyle={styles.submitButton} clickEvent={onSubmit}>
          <p>{t('BOOKING.MODAL.DUPLICATE_RESERVE.PAID')}</p>
        </ModalButtonLayout>
      </div>
    </ModalLayout>
  )
}
